import { useI18n } from "../i18n/I18nProvider.js";

export function LanguageSettings() {
  const { locale, selectLocale, t } = useI18n();

  return (
    <section
      aria-labelledby="language-settings-title"
      className="settings-card language-settings"
      role="group"
    >
      <h2 id="language-settings-title">{t("language.choose")}</h2>
      <p>{t("language.current")}</p>
      <div className="segmented-control">
        {(["th", "en"] as const).map((option) => (
          <button
            aria-pressed={locale === option}
            key={option}
            onClick={() => selectLocale(option)}
            type="button"
          >
            {t(`language.${option}`)}
          </button>
        ))}
      </div>
    </section>
  );
}
